import { Link, generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";
import { RoomHeaderAndTabs } from "@/components/features/items/_components";

import { Button } from "@/components/ui/button/button";

import { useGetRoomPriceRankDeprecatedPageParams } from "./_hooks/use-get-room-price-rank-deprecated-page-params";

export const RoomPriceRankDeprecatedPage = () => {
	const { hotelID } = useGetRoomPriceRankDeprecatedPageParams();

	return (
		<PageMeta title="部屋の料金設定" url={generatePath(PATHS.HOTEL.ITEMS.ROOM.PRICE_RANK_DEPRECATED, { hotelID })}>
			<div>
				<FeatureIslandContainer>
					<RoomHeaderAndTabs
						hotelID={hotelID}
						headerProps={{
							title: "部屋の料金設定",
						}}
					/>

					<FeatureIslandMainWithBackGround>
						{/* ナッジ導線: サイドメニューへの案内 */}
						<div className="flex flex-col items-center gap-6 py-12">
							<div className="space-y-2 text-center">
								<p className="text-lg font-semibold">この機能は移動しました</p>
								<p className="text-sm text-caption-50">
									部屋料金設定はサイドメニューの「部屋料金設定」からアクセスできます。
								</p>
							</div>
							<Link to={generatePath(PATHS.HOTEL.ITEMS.ROOM.PRICE_RANK, { hotelID })}>
								<Button type="button" size="xl">
									部屋料金設定へ移動
								</Button>
							</Link>
						</div>
					</FeatureIslandMainWithBackGround>
				</FeatureIslandContainer>
			</div>
		</PageMeta>
	);
};

RoomPriceRankDeprecatedPage.displayName = "RoomPriceRankDeprecatedPage";
